import React from 'react';
import { Helmet } from 'react-helmet';
import { Button } from 'reactstrap';
import { useAuth } from './Auth/AuthContext';
import { AI_UTILITIES } from '../constants/aiUtilities';
import { useTheme } from './hooks/useTheme';
import '../ai/Shared.css';
import './Home.css';

export const Home = () => {
    const { theme } = useTheme();
    const auth = useAuth();
    const hasPermission = (p) => auth.checkPermission(p);

    const getIcon = (lightIcon, darkIcon) => {
        return theme === 'light' ? lightIcon : darkIcon;
    };

    const renderButton = (href, lightIcon, darkIcon, text, permission) => {
        if (!hasPermission(permission)) return null;

        const icon = getIcon(lightIcon, darkIcon);

        return (
            <Button
                key={href}
                href={href}
                className="d-flex align-items-center dt1520-button active-dt1520-button default-button menu-button"
                outline
                draggable="false"
            >
                <img src={icon} alt="Логотип" className='menu-icon' />
                <span>{text}</span>
            </Button>
        );
    };

    return (
        <div>
            <Helmet>
                <title>Интеллектуальные утилиты</title>
            </Helmet>
            <section className="menu-section">
                <div className="menu-grid">
                    {renderButton(
                        AI_UTILITIES.TRANSCRIBE.path,
                        AI_UTILITIES.TRANSCRIBE.lightIcon,
                        AI_UTILITIES.TRANSCRIBE.darkIcon,
                        AI_UTILITIES.TRANSCRIBE.name,
                        AI_UTILITIES.TRANSCRIBE.permission,
                    )}

                    {renderButton(
                        AI_UTILITIES.DIARIZE.path,
                        AI_UTILITIES.DIARIZE.lightIcon,
                        AI_UTILITIES.DIARIZE.darkIcon,
                        AI_UTILITIES.DIARIZE.name,
                        AI_UTILITIES.DIARIZE.permission,
                    )}

                    {renderButton(
                        AI_UTILITIES.SUMMARIZE_RESUME.path,
                        AI_UTILITIES.SUMMARIZE_RESUME.lightIcon,
                        AI_UTILITIES.SUMMARIZE_RESUME.darkIcon,
                        AI_UTILITIES.SUMMARIZE_RESUME.name,
                        AI_UTILITIES.SUMMARIZE_RESUME.permission,
                    )}

                    {renderButton(
                        AI_UTILITIES.UNIVERSAL_SUMMARIZE.path,
                        AI_UTILITIES.UNIVERSAL_SUMMARIZE.lightIcon,
                        AI_UTILITIES.UNIVERSAL_SUMMARIZE.darkIcon,
                        AI_UTILITIES.UNIVERSAL_SUMMARIZE.name,
                        AI_UTILITIES.UNIVERSAL_SUMMARIZE.permission,
                    )}

                    {renderButton(
                        AI_UTILITIES.DEPERSONALIZE.path,
                        AI_UTILITIES.DEPERSONALIZE.lightIcon,
                        AI_UTILITIES.DEPERSONALIZE.darkIcon,
                        AI_UTILITIES.DEPERSONALIZE.name,
                        AI_UTILITIES.DEPERSONALIZE.permission,
                    )}

                    {renderButton(
                        AI_UTILITIES.RETELLING.path,
                        AI_UTILITIES.RETELLING.lightIcon,
                        AI_UTILITIES.RETELLING.darkIcon,
                        AI_UTILITIES.RETELLING.name,
                        AI_UTILITIES.RETELLING.permission,
                    )}

                    {renderButton(
                        AI_UTILITIES.STANDARD_CONTROL_PSA.path,
                        AI_UTILITIES.STANDARD_CONTROL_PSA.lightIcon,
                        AI_UTILITIES.STANDARD_CONTROL_PSA.darkIcon,
                        AI_UTILITIES.STANDARD_CONTROL_PSA.name,
                        AI_UTILITIES.STANDARD_CONTROL_PSA.permission,
                    )}

                    {renderButton(
                        AI_UTILITIES.MARKET_PRICE_ANALYSIS.path,
                        AI_UTILITIES.MARKET_PRICE_ANALYSIS.lightIcon,
                        AI_UTILITIES.MARKET_PRICE_ANALYSIS.darkIcon,
                        AI_UTILITIES.MARKET_PRICE_ANALYSIS.name,
                        AI_UTILITIES.MARKET_PRICE_ANALYSIS.permission,
                    )}

                    {renderButton(
                        AI_UTILITIES.INVOICE_RECOGNIZER.path,
                        AI_UTILITIES.INVOICE_RECOGNIZER.lightIcon,
                        AI_UTILITIES.INVOICE_RECOGNIZER.darkIcon,
                        AI_UTILITIES.INVOICE_RECOGNIZER.name,
                        AI_UTILITIES.INVOICE_RECOGNIZER.permission,
                    )}

                    {renderButton(
                        AI_UTILITIES.TRANSCRIPT.url,
                        AI_UTILITIES.TRANSCRIPT.lightIcon,
                        AI_UTILITIES.TRANSCRIPT.darkIcon,
                        AI_UTILITIES.TRANSCRIPT.name,
                        AI_UTILITIES.TRANSCRIPT.permission,
                    )}
                </div>
            </section>
        </div>
    );
};

Home.displayName = 'Home';